
export const env = {
  development : {
    SENTRY_DSN: "",
    GA_TRACKING_ID: "UA-115073919-2",
  },
  staging : {
  },
  production : {
    SENTRY_DSN: "https://989d625f26224427b77e674f73268e20@o150151.ingest.us.sentry.io/1213118",
    GA_TRACKING_ID: "UA-115073919-1"
  }
};

// Vite sets the mode to 'development' for `vite`, 'production' for `vite build`,
// and to whatever `--mode` says, for example 'staging'.
const mode = env[import.meta.env.MODE] ? import.meta.env.MODE : 'development';

export function getEnvVal(name) {
  return typeof env[mode][name] === 'undefined' ? env.development[name] : env[mode][name];
}
